import { urlParts } from 'common/tools/network/url';

export default function getHostName() {
  return document.referrer
    ? urlParts(document.referrer).host
    : window.location.hostname;
}
